<template>
  <div class="container">
    <h1 class="h1">
      Billing Profile <span v-if="!viewByUser">(Admin)</span>
    </h1>
    <div class="row margin-bottom-2" v-if="viewByUser">
      <div class="col-xs-4">
        <DevAppDropDownComponent role="sms" @devapp-changed="devAppChanged"/>
      </div>
    </div>
    <sdx-loading-spinner id="spinner-billing-profiles" size="large" sr-hint="Loading. Please wait."
                         class="spinner-dashboard hidden"></sdx-loading-spinner>
    <div id="no-billing-profiles" v-if="viewByUserLoading==false && profile==null">
      No billing profile for this subscription.
    </div>
    <div id="billing-profiles" v-if="viewByUserLoading==false && profile!=null">
      <h5 class="h5">Address</h5>
      <div class="row" v-if="billingAddressCompanyTable">
        <div class="col table table__wrapper table--responsive table--highlight">
          <table data-init="auto">
            <thead>
            <tr>
              <th class="text-align-left">
              <span v-if="isCompany">
                Company<br/>
                <a href="https://www.zefix.ch" target="zefix">Zefix</a>
              </span>
                <span v-else>
                Name<br/>
                Birthday
              </span>
              </th>
              <th class="text-align-left">Department</th>
              <th class="text-align-left">Street</th>
              <th class="text-align-left">Zip</th>
              <th class="text-align-left">City</th>
              <th class="text-align-center">Country</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-align-left">
              <span v-if="isCompany">
                {{ this.profile.company }}<br/>
                <a :href="'https://www.zefix.ch/de/search/entity/list?mainSearch='+ this.profile.zefix  +'&searchTypeExact=true'"
                   target="zefix">{{ this.profile.zefix }}</a>
              </span>
                <span v-else>
                {{ this.profile.firstName }} {{ this.profile.lastName }}<br/>
                {{ this.profile.birthday }}
                </span>
              </td>
              <td class="text-align-left">{{ this.profile.department }}</td>
              <td class="text-align-left">{{ this.profile.street }}</td>
              <td class="text-align-left">{{ this.profile.zip }}</td>
              <td class="text-align-left">{{ this.profile.city }}</td>
              <td class="text-align-center">
                <FlagComponent :country="this.profile.country"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col table table__wrapper table--responsive table--highlight">
          <table data-init="auto">
            <thead>
            <tr>
              <th class="text-align-left">Name<br/>Birthday</th>
              <th class="text-align-left">Street</th>
              <th class="text-align-left">Zip</th>
              <th class="text-align-left">City</th>
              <th class="text-align-center">Country</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-align-left">
                {{ this.profile.firstName }} {{ this.profile.lastName }}<br/>
                {{ this.profile.birthday }}
              </td>
              <td class="text-align-left">{{ this.profile.street }}</td>
              <td class="text-align-left">{{ this.profile.zip }}</td>
              <td class="text-align-left">{{ this.profile.city }}</td>
              <td class="text-align-center">
                <FlagComponent :country="this.profile.country"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <h5 class="h5 margin-top-3">Digital Billing</h5>
      <div class="row">
        <div class="col table table__wrapper table--responsive table--highlight">
          <table data-init="auto">
            <thead>
            <tr>
              <th class="text-align-left">E-Mail</th>
              <th class="text-align-left">Language</th>
              <th class="text-align-left">Price / SMS</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-align-left">{{ this.profile.billEmail }}</td>
              <td class="text-align-left">
                <FlagComponent :country="this.profile.billLanguage"/>
              </td>
              <td class="text-align-left">
                CHF {{ this.profile.priceSwisscom / 100 }} to Swisscom<br/>
                CHF {{ this.profile.priceNational / 100 }} to National<br/>
                CHF {{ this.profile.priceInternational / 100 }} to International
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <h5 class="h5 margin-top-3">Contact Person</h5>
      <div class="row">
        <div class="col table table__wrapper table--responsive table--highlight">
          <table data-init="auto">
            <thead>
            <tr>
              <th class="text-align-left">First Name</th>
              <th class="text-align-left">Last Name</th>
              <th class="text-align-left">E-Mail</th>
              <th class="text-align-left">Phone Number</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-align-left">{{ this.profile.contactPersonFirstName }}</td>
              <td class="text-align-left">{{ this.profile.contactPersonLastName }}</td>
              <td class="text-align-left">{{ this.profile.contactPersonEmail }}</td>
              <td class="text-align-left">{{ this.profile.contactPersonPhoneNumber }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="admin-div  margin-top-3" v-if="userService.isAtLeastAdminWithoutFmg()">
        <div class="row margin-top-2">
          <div class="col table table__wrapper table--responsive table--highlight">
            <table data-init="auto">
              <thead>
              <tr class="admin-div font-white font--semi-bold">
                <th>Customer Billing Reference</th>
                <th>SCN</th>
                <th>esBill Contract ID</th>
                <th>Comment</th>
              </tr>
              </thead>
              <tbody>
              <tr class="admin-div font-white">
                <td>{{ this.profile.customerBillingReference }}</td>
                <td v-if="this.profile.scn">{{ this.profile.scn }}</td>
                <td v-else>
                  Check if customer already exist in <a href="https://extranet.swisscom.ch/">B2B Extranet</a> and take location number for SCN<br/>
                  or let create the customer via <a :href="getCreateCustomerLink()">Email</a>
                </td>
                <td v-if="this.profile.backendContractId">{{ this.profile.backendContractId }}</td>
                <td v-else><a
                    href="https://wiki.swisscom.com/spaces/SEP/pages/1866917297/Billing+Arbeitsanweisung+Messaging+Neukunden+Onboading"
                    target="_blank">Create Billing Profile via SNOW Ticket</a></td>
                <td>{{ this.profile.comment }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <br/>
      <div class="row flex-items-xs-between" v-if="isAdmin && !viewByUser">
        <div class="col-xs-4">
          <sdx-button
              id="buttonOverview"
              label="Overview"
              theme="secondary"
              @click="goToRoute('/billing/profiles')"
          />
        </div>
        <div class="col-xs-4  text-align-right" v-if="isAdmin && !viewByUser">
          <sdx-button
              id="buttonEdit"
              label="Edit"
              theme="secondary"
              @click="goToRoute('/billing/profiles/edit')"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import billingService from "@/modules/billingProfile/service";
import loadingSpinnerService from '@/services/loading-spinner.service';
import FlagComponent from "@/components/FlagComponent.vue";
import userService from "@/services/user.service";
import {showAlert} from "@/services/notification.service";
import DevAppDropDownComponent from "@/components/DevAppDropDownComponent.vue";
import {logger} from "@/services/logger.service";
import envService from "@/services/env.service";

export default {
  computed: {
    userService() {
      return userService
    }
  },
  components: {DevAppDropDownComponent, FlagComponent},
  data() {
    return {
      profile: [],
      isAdmin: true,
      viewByUser: true,
      viewByUserLoading: true,
      billingAddressCompanyTable: true,
    }
  },
  async beforeCreate() {
    this.isAdmin = await userService.isAtLeastAdminWithoutFmg();
    this.viewByUser = this.$router.currentRoute.value.path === '/billing/profiles/view/user';
    logger.debug("Mode viewByUser: " + this.viewByUser)
    if (!this.viewByUser) {
      loadingSpinnerService.hide("billing-profiles")
      this.viewByUserLoading = false;
      await this.getProfile();
    }
  },
  methods: {
    devAppChanged: async function (webId) {
      loadingSpinnerService.show("billing-profiles")
      this.viewByUserLoading = true;
      //this.webId = webId;
      await this.getProfileByWebId(webId);
      this.viewByUserLoading = false;
      loadingSpinnerService.hide("billing-profiles")
    },

    async getProfileByWebId(webId) {
      logger.debug("getProfileByWebId... ");
      try {
        var response = await billingService.getBillingProfileByWebId(webId)
        if (response.status === 204) {
          this.profile = null;
        } else {
          this.profile = response.data
          if (this.profile.company === '') {
            this.billingAddressCompanyTable = false;
          }
        }
      } catch (error) {
        showAlert(error.message)
      }
    },
    async getProfile() {
      logger.debug("getProfile... ");
      try {
        this.profile = (await billingService.getBillingProfile(billingService.getBillingProfileIdFromSession())).data
        if (this.profile.company === '') {
          this.billingAddressCompanyTable = false;
        }
      } catch (error) {
        showAlert(error.message)
      }
    },
    goToRoute(route) {
      this.$router.push(route);
    },
    isCompany() {
      return this.profile.company !== '';
    },
    getCreateCustomerLink() {
      return "mailto:" + envService.getEmail4CreateCustomer() + "?subject=Kundenerfassung "+
      (this.profile.company==''? "&cc=" + envService.getEmail4CreateCustomerCC():"") +
      "&body=" +
          encodeURIComponent(
              "Hallo\n" +
              "\n" +
              "Könnt ihr bitte folgenden Kunden erfassen?\n" +
              "\n" +
              (this.isCompany() ?
                      "Firmenindex: " + this.profile.zefix + "\n" +
                      "\n" +
                      this.profile.company + "\n"
                      :
                      "Privatperson: \n" +
                      "\n" +
                      this.profile.firstName + " " + this.profile.lastName + "\n" +
                      "Geburtstag: " + this.profile.birthday + "\n"
              ) +
              this.profile.department + "\n" +
              this.profile.street + "\n" +
              this.profile.country + "-" + this.profile.zip + " " + this.profile.city + "\n" +
              "\n" +
              "Bitte ENT-relevant Flag setzen.\n" +
              "\n" +
              "Danke")
    }
  }
}
</script>

<style>
.font-white {
  color: white;
}

.admin-div {
  background-color: #862351;
  border-radius: 10px;
  margin-top: 10px;
  padding-top: 1px !important;
  padding-bottom: 6px !important;
}
</style>